import Link from "@tiptap/extension-link";

// Shared with the Markdown converter: stored documents persist these link attribute defaults.

export const DEFAULT_LINK_ATTRS: Record<string, string> = {
  class: "text-primary underline underline-offset-2",
  rel: "noopener noreferrer nofollow",
  target: "_blank",
};

/** Autolink stays a plugin; this just stops typing after a URL inheriting the mark. */
export const NonInclusiveLink = Link.extend({ inclusive: () => false });
